import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import companies from 'modules/core/store/collections/companies'

import * as styles from 'modules/payroll_bundle/pages/SelfServicePage/index.vanilla.css'

interface headerProps {
  title: string
  open: boolean
  toggle: (value: boolean) => () => void
  hasPulseAnimation?: boolean
  onHandle: React.Dispatch<React.SetStateAction<boolean>>
}

const CardHeader = ({ open, toggle, title, hasPulseAnimation = false, onHandle }: headerProps) => {
  const handleClick = () => {
    onHandle(true)
    toggle(!open)()

    track(trackingEvents.payroll.userTogglesExplanationCard, {
      company_id: companies.current.attributes.id,
      explanation_card: title,
      action: open ? 'close' : 'open',
    })
  }

  return (
    <Box
      flexDirection="row"
      justifyContent="spaceBetween"
      alignItems="center"
      width="full"
      padding="s12"
      border={{
        bottom: {
          width: 's1',
          style: 'solid',
          color: 'grey400',
        },
      }}
    >
      <Text.Normal size="300" weight="semibold" color="grey1000">
        {title}
      </Text.Normal>

      <Box
        {...(hasPulseAnimation ? { className: styles.blob } : {})}
        style={{
          cursor: 'pointer',
        }}
        onClick={handleClick}
        aria-label={title}
        {...(open
          ? {
              background: 'viridian200',
              border: {
                all: {
                  width: 's2',
                  style: 'solid',
                  color: 'viridian600',
                },
              },
            }
          : {
              border: {
                all: {
                  width: 's2',
                  style: 'solid',
                  color: 'grey400',
                },
              },
            })}
        padding="s1"
        borderRadius={{
          all: 'rel1000',
        }}
      >
        <Icon.Medium {...(open ? { color: 'viridian600' } : {})} icon="info" />
      </Box>
    </Box>
  )
}

export default CardHeader
